<template>
  <div><slot></slot></div>
</template>

<style scoped>
div {
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(56, 55, 55, 0.26);
  padding: 1rem;
  margin: 1rem auto;
  max-width: 50rem;
  word-wrap: break-word;
  background-color: #c9c2c0;
}
</style>
